import apiUrl from '../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import {
	BasicSelect
} from 'vue-search-select';
import {
	Validator
} from 'vee-validate'

export default {
	name: 'SorterSQSDetails',
	components: {
		VueElementLoading,
		BasicSelect
	},
	props: [],
	data() {
		return {
			isLoading: false,
			hubLoading: '',
			sqsUrl:'',
			sqstypelist:[
				{
	        value: 1,
	        text: "ShipmentSQS"
	      }, {
	        value: 2,
	        text: "BaginSQS"
	      },{
	        value: 3,
	        text: "ManifestShipmentSQS"
	      },
				{
					value: 4,
					text: "InBoundShipmentSQS"
				},
				{
					value: 5,
					text: "MissingShipmentSQS"
				}
			],
			hubid: '',
			hubName:'',
			sqsTypeId:'',
			SQSType:'',
			HubNameData: [],
			createdBy:'',
			DestHubNameData: [],
			hubNameObjData: {
				value: "",
				text: "",
				hubName:""
			},
			sqsTypeOption: {
				value: "",
				text: ""
			}
		}
	},
	computed: {},
	filters: {},
	mounted() {
		this.getHubName();
		var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userData = userdetail;
    this.createdBy = userdetail[0].email;
	},
	methods: {
		getHubName() {
			this.hubLoading = 'Loading Hub...'
			var i = 0;
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					this.hubLoading = ''
					var HubNameData = result.data.ResponseData
					for (i = 0; i < HubNameData.length; i++) {
						this.DestHubNameData.push({
							value: HubNameData[i].HubID,
							text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')',
							hubName:HubNameData[i].HubName
						})
						this.HubNameData = this.DestHubNameData
					}
				}, error => {
					console.error(error)
				})
		},
		selectedHub(hubNameObjData) {
			this.hubNameObjData = hubNameObjData;
			this.hubid = hubNameObjData.value;
			this.hubName=hubNameObjData.hubName;
		},
		selectSQSType(sqsTypeOption) {
			this.sqsTypeOption = sqsTypeOption;
			this.sqsTypeId = sqsTypeOption.text;
		},
		clearID() {
			this.isLoading = false
			this.hubLoading = ''
			this.hubid = ''
			this.hubNameObjData= {
				value: "",
				text:"",
				hubName:""
			},
			this.sqsTypeOption= {
				value: "",
				text: ""
			}
			this.sqsUrl='',
			this.$validator.reset();
		},
		onSubmit: function (event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
					this.PushSQSDetails();
			}).catch((errors) => {
				console.log('errors exist', errors)
			});
		},
		PushSQSDetails() {

			this.isLoading = true;
			this.sqsUrl=this.sqsUrl.replaceAll(/\s/g,'')
			this.input = ({
				sorterLocation: this.hubid,
				sorterLocationName:this.hubName,
				sqsType: this.sqsTypeId,
				sqsName:this.sqsUrl,
				createdBy:this.createdBy
						})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'saveSQSDetails',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.isLoading = false;
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage)
					this.clearID()
				} else {
					this.isLoading = false
					this.$alertify.error(result.data.ReturnMessage)
				}
			}, error => {
				console.error(error)
				this.isLoading = false
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/SorterSQSDetails/SorterSQSDetails.js